var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_6380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6625 3.71002C9.26479 3.56904 9.88143 3.49857 10.5 3.50002C16.625 3.50002 20.125 10.5 20.125 10.5C19.5939 11.4937 18.9604 12.4292 18.235 13.2913M12.355 12.355C12.1147 12.6129 11.8249 12.8198 11.5029 12.9633C11.1809 13.1067 10.8333 13.1839 10.4808 13.1901C10.1284 13.1963 9.77827 13.1315 9.45141 12.9995C9.12455 12.8674 8.82763 12.6709 8.57837 12.4217C8.3291 12.1724 8.13259 11.8755 8.00057 11.5486C7.86855 11.2218 7.80371 10.8717 7.80993 10.5192C7.81615 10.1667 7.8933 9.81914 8.03677 9.49714C8.18024 9.17514 8.3871 8.88534 8.645 8.64502M15.6975 15.6975C14.2018 16.8376 12.3805 17.4693 10.5 17.5C4.375 17.5 0.875 10.5 0.875 10.5C1.9634 8.47168 3.47299 6.69955 5.3025 5.30252L15.6975 15.6975Z",
    stroke: "#667080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 0.875L20.125 20.125",
    stroke: "#667080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.c900f23a48d2440c80d33a63863ba198.svg";
export { ForwardRef as ReactComponent };